/**
 * Ray3 intersection functions
 * @module
 */
import { ZERO_EPSILON } from "./core";
import type { Vec3 } from "./vec3";
import { vec3Dot, vec3Result, vec3Sub } from "./vec3";

const { abs } = Math;

export function intersectRay3PlaneWithNormal(
  rayOriginX: number,
  rayOriginY: number,
  rayOriginZ: number,
  rayDirX: number,
  rayDirY: number,
  rayDirZ: number,
  planeOriginX: number,
  planeOriginY: number,
  planeOriginZ: number,
  planeNormX: number,
  planeNormY: number,
  planeNormZ: number,
): Vec3 | null {
  const denom = vec3Dot(planeNormX, planeNormY, planeNormZ, rayDirX, rayDirY, rayDirZ);

  // parallel case
  if (abs(denom) < ZERO_EPSILON) {
    return null;
  }

  const [ddx, ddy, ddz] = vec3Sub(planeOriginX, planeOriginY, planeOriginZ, rayOriginX, rayOriginY, rayOriginZ);
  const num = vec3Dot(ddx, ddy, ddz, planeNormX, planeNormY, planeNormZ) / denom;

  vec3Result[0] = num * rayDirX + rayOriginX;
  vec3Result[1] = num * rayDirY + rayOriginY;
  vec3Result[2] = num * rayDirZ + rayOriginZ;

  return vec3Result;
}
